import React, {useContext, useEffect, useState} from 'react';
import './PgeFilters.scss';
import {Button, DateInput, SelectInput} from "../_common";
import {I18nContext} from "../../contexts/i18nContext";
import {getOptionsList} from "../../helpers/helpers";

const PgeFilters = ({showFilters, toggleShowFilters, setFilters, filters, selections, usersForDropdowns, archived}) => {
  const { t } = useContext(I18nContext);
  const [filterValues, setFilterValues] = useState({
    companyId: '',
    address: '',
    pgeRegionId: '',
    orderNumber: '',
    conditionsNumber: '',
    agreementNumber: '',
    personResponsibleForProjectId: '',
    personResponsibleForImplementationId: '',
    clientFullName: '',
    fromDueDate: '',
    toDueDate: '',
    orderType: '',
    state: '',
    fromCreationDate: '',
    toCreationDate: '',
    fromLastModificationDate: '',
    toLastModificationDate: ''
  });

  useEffect(() => {
    if (!showFilters) {
      clearFilterValues()
    } else {
      setFilterValues(filters);
    }
  }, [showFilters]);

  useEffect(() => {
    setFilterValues(filters);
  }, [filters]);

  const usersOptions = usersForDropdowns.map(user => ({id: user.id, label: user.firstName + " " + user.lastName}));
  const subcompanyOptions = getOptionsList(selections, 'Firma Wolte');
  const pgeRegionOptions = getOptionsList(selections, 'PGE rejon');
  const pgeOrderTypeOptions = getOptionsList(selections, 'PGE typ zlecenia');
  const projectStateOptions = [
    {id: "project", label: t('project')},
    {id: "implementation", label: t('implementation')}
  ];
  const projectStateOptionsArchived = [
    {id: "canceled", label: t('canceled')},
    {id: "completed", label: t('finished')}
  ];

  const changeFilterValue = (name, value) => {
    let newFilterValues = { ...filterValues };
    if (!!value) {
      newFilterValues[name] = value;
    } else {
      delete newFilterValues[name];
    }
    setFilterValues(newFilterValues);
  };

  const applyFilters = () => {
    setFilters(filterValues);
    toggleShowFilters();
  };

  const clearFilters = () => {
    setFilters({});
    clearFilterValues();
    toggleShowFilters();
  };

  const clearFilterValues = () => {
    setFilterValues({
      companyId: '',
      address: '',
      pgeRegionId: '',
      orderNumber: '',
      conditionsNumber: '',
      agreementNumber: '',
      personResponsibleForProjectId: '',
      personResponsibleForImplementationId: '',
      clientFullName: '',
      fromDueDate: '',
      toDueDate: '',
      orderType: '',
      state: '',
      fromCreationDate: '',
      toCreationDate: '',
      fromLastModificationDate: '',
      toLastModificationDate: ''
    });
  };

  return (
    <div
      className='PgeFilters'
      onKeyDown={e => {
        if (e.key === 'Enter') {
          applyFilters();
        }
      }}
      tabIndex={-1}
    >
      <div className='filtersItems'>
        <div className='filtersItem'>
          <div className='filterLabel'>
            {t('subcompany', 'asIs')}
          </div>
          <SelectInput
            name='companyId'
            options={subcompanyOptions}
            onSelect={changeFilterValue}
            value={filterValues.companyId}
            small
            noMargin
            filter
          />
        </div>
        <div className='filtersItem'>
          <div className='filterLabel'>
            {t('investment address')}
          </div>
          <input
            className='filterInput'
            type='text'
            onChange={e => changeFilterValue('address', e.target.value)}
            value={filterValues.address}
          />
        </div>
        <div className='filtersItem'>
          <div className='filterLabel'>
            {t('order number')}
          </div>
          <input
            className='filterInput'
            type='text'
            onChange={e => changeFilterValue('orderNumber', e.target.value)}
            value={filterValues.orderNumber}
          />
        </div>
        <div className='filtersItem'>
          <div className='filterLabel'>
            {t('conditions number')}
          </div>
          <input
            className='filterInput'
            type='text'
            onChange={e => changeFilterValue('conditionsNumber', e.target.value)}
            value={filterValues.conditionsNumber}
          />
        </div>
        <div className='filtersItem'>
          <div className='filterLabel'>
            {t('framework agreement number')}
          </div>
          <input
            className='filterInput'
            type='text'
            onChange={e => changeFilterValue('agreementNumber', e.target.value)}
            value={filterValues.agreementNumber}
          />
        </div>
        <div className='filtersItem'>
          <div className='filterLabel'>
            {t('pge region', 'asIs')}
          </div>
          <SelectInput
            name='pgeRegionId'
            options={pgeRegionOptions}
            onSelect={changeFilterValue}
            value={filterValues.pgeRegionId}
            small
            noMargin
            filter
          />
        </div>
        <div className='filtersItem'>
          <div className='filterLabel'>
            {t('person responsible for the project')}
          </div>
          <SelectInput
            name='personResponsibleForProjectId'
            options={usersOptions}
            onSelect={changeFilterValue}
            value={filterValues.personResponsibleForProjectId}
            small
            noMargin
            filter
          />
        </div>
        <div className='filtersItem'>
          <div className='filterLabel'>
            {t('person responsible for the implementation')}
          </div>
          <SelectInput
            name='personResponsibleForImplementationId'
            options={usersOptions}
            onSelect={changeFilterValue}
            value={filterValues.personResponsibleForImplementationId}
            small
            noMargin
            filter
          />
        </div>
        <div className='filtersItem'>
          <div className='filterLabel'>
            {t('client name')}
          </div>
          <input
            className='filterInput'
            type='text'
            onChange={e => changeFilterValue('clientFullName', e.target.value)}
            value={filterValues.clientFullName}
          />
        </div>
        <div className='filtersItem'>
          <div className='filterLabel'>
            {t('due date')}
          </div>
          <div className='datesWrapper'>
            <DateInput
              name='fromDueDate'
              value={filterValues.fromDueDate}
              onChange={changeFilterValue}
              noMargin
              small
            />
            <DateInput
              name='toDueDate'
              value={filterValues.toDueDate}
              onChange={changeFilterValue}
              noMargin
              small
            />
          </div>
        </div>
        <div className='filtersItem'>
          <div className='filterLabel'>
            {t('order type')}
          </div>
          <SelectInput
            name='orderType'
            options={pgeOrderTypeOptions}
            onSelect={changeFilterValue}
            value={filterValues.orderType}
            small
            noMargin
            filter
          />
        </div>
        <div className='filtersItem'>
          <div className='filterLabel'>
            {t('created at')}
          </div>
          <div className='datesWrapper'>
            <DateInput
              name='fromCreationDate'
              value={filterValues.fromCreationDate}
              onChange={changeFilterValue}
              small
              noMargin
            />
            <DateInput
              name='toCreationDate'
              value={filterValues.toCreationDate}
              onChange={changeFilterValue}
              small
              noMargin
            />
          </div>
        </div>
        <div className='filtersItem'>
          <div className='filterLabel'>
            {t('last modified')}
          </div>
          <div className='datesWrapper'>
            <DateInput
              name='fromLastModificationDate'
              value={filterValues.fromLastModificationDate}
              onChange={changeFilterValue}
              noMargin
              small
            />
            <DateInput
              name='toLastModificationDate'
              value={filterValues.toLastModificationDate}
              onChange={changeFilterValue}
              noMargin
              small
            />
          </div>
        </div>
        <div className='filtersItem'>
          <div className='filterLabel'>
            {t('project state')}
          </div>
          <SelectInput
            name='state'
            options={!archived ? projectStateOptions : projectStateOptionsArchived}
            onSelect={changeFilterValue}
            value={filterValues.state}
            small
            noMargin
            filter
          />
        </div>
      </div>
      <div className='filtersButtons'>
        <div className='filterButtonMobile'>
          <Button label='cancel' type='secondary' action={toggleShowFilters}/>
        </div>
        <Button label='clear filters' type='secondary' action={clearFilters} fullWidth/>
        <Button label='apply' action={applyFilters} fullWidth/>
      </div>
    </div>
  );
};

export default PgeFilters;
